export default __webpack_public_path__ + "static/media/Royal Dragon Elite Vambraces.98db62c4.jpg";